import type { QueryClient } from '@tanstack/react-query'

import {
  getListPaymentMethodsApiV1PaymentMethodsGetQueryKey,
  listPaymentMethodsApiV1PaymentMethodsGet,
} from '#/shared/api/generated/billing/theCargoBilling'

import { isActiveCardGatewayMethod } from '../lib/card-gateway'

const PAGE_SIZE = 100
const LIST_PARAMS = { size: PAGE_SIZE }

export async function fetchCardGatewayMethodId(
  queryClient: QueryClient,
): Promise<string | undefined> {
  const response = await queryClient.fetchQuery({
    queryKey: getListPaymentMethodsApiV1PaymentMethodsGetQueryKey(LIST_PARAMS),
    queryFn: ({ signal }) =>
      listPaymentMethodsApiV1PaymentMethodsGet(LIST_PARAMS, signal),
  })
  return response.data.items.find(isActiveCardGatewayMethod)?.id
}
